import React, { useState } from 'react';
import { UsersManagement } from './UsersManagement';
import { UserProfilePage } from './UserProfilePage';
import { AdminUser } from '../../../types/users';
interface AppUsersManagementProps {
  onBack: () => void;
}
export function AppUsersManagement({
  onBack
}: AppUsersManagementProps) {
  const [selectedUser, setSelectedUser] = useState<AdminUser | null>(null);
  const handleNavigateToUser = (user: AdminUser) => {
    setSelectedUser(user);
  };
  const handleBackToList = () => {
    setSelectedUser(null);
  };
  const handleSaveUser = (updatedUser: Partial<AdminUser>) => {
    console.log('Saving user:', updatedUser);
    // In production, this would update the user via API
    setSelectedUser(null);
  };
  if (selectedUser) {
    return <UserProfilePage user={selectedUser} onBack={handleBackToList} onSave={handleSaveUser} data-id="element-842" />;
  }
  return <UsersManagement onBack={onBack} onNavigateToUser={handleNavigateToUser} data-id="element-843" />;
}